// extracted by mini-css-extract-plugin
export default {"container":"NumberInput__container___EHNYj"};